import { IPaymentPageCompletionStorage, IPaymentPageDetail, IPaymentPageInitResponse } from "@app-models";
import { atom } from "recoil";
import implementPersist, { implementGetAndDeleteFromLocalStorage, implementSessionPersist } from "./implement-persist";

export const paymentPageDetail = atom<IPaymentPageDetail | null>({
  key: "paymentPageDetail",
  default: null,
  effects_UNSTABLE: implementPersist("paymentPageDetailKey"),
});

export const paymentPageInitResponse = atom<IPaymentPageInitResponse | null>({
  key: "paymentPageInitResponse",
  default: null,
});

export const amountOptionSelected = atom<string | null>({
  key: "amountOptionKey",
  default: null,
});

export const dynamicAmountValue = atom<string | null>({
  key: "dynamicAmountValueKey",
  default: "0",
});

export const pagePaymentCompletionStorage = atom<IPaymentPageCompletionStorage | null>({
  key: "pagePaymentCompletionStorage",
  default: null,
  effects_UNSTABLE: implementGetAndDeleteFromLocalStorage("pagePaymentCompletionStorageKey"),
});

export const paymentPageInitResponseQueryData =
  atom<IPaymentPageInitResponse | null>({
    key: "paymentPageInitResponseQueryData",
    default: null,
    effects_UNSTABLE: implementSessionPersist("paymentPageInitResponseQueryDataKey"),
  });
